import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { Button, Modal, Row, Col } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from 'react-redux'
import { useAuth } from '../../components/auth/useAuth'
import { getDepartments, addDepartment, editDepartment } from '../../actions/departmentsActions'
import { CustomDataTable } from '../../components/design/Datatables/CustomDataTable'
import Loader from '../../components/loaders/Loader'
import Swal from 'sweetalert2'

export default function Departments() {
    const { t } = useTranslation()
    const location = useLocation()
    const dispatch = useDispatch()
    const { clientauth } = useAuth()

    const { departments, loading, resultdepartment } = useSelector(state => state.departments)

    const [modalShow, setModalShow] = useState(false)
    const [formState, setFormState] = useState({})
    const [isRegistering, setIsRegistering] = useState(false)
    const [isEditing, setIsEditing] = useState(false)

    const [page] = useState(1)
    const [limit] = useState(25)
    const [search, setSearch] = useState('')

    useEffect(() => {
        if (clientauth) {
            dispatch(getDepartments(page, limit, search))
        }
    }, [dispatch, clientauth, location, page, limit, search])

    const openModal = () => {
        setIsEditing(false)
        setFormState({
            name: '',
            code: '',
            active: true
        })
        setModalShow(true)
    }

    const selectDepartment = (department) => {
        setIsEditing(true)
        setFormState(department)
        setModalShow(true)
    }

    const handleInputChange = ({ target }) => {
        setFormState({
            ...formState,
            [target.name]: target.value
        })
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        setIsRegistering(true)
        if (isEditing) {
            await dispatch(editDepartment(formState._id, formState))
        } else {
            await dispatch(addDepartment(formState))
        }
        setIsRegistering(false)
    }

    const closeModal = () => {
        setModalShow(false)
    }

    useEffect(() => {
        if (resultdepartment) {
            dispatch({ type: 'DEPARTMENT_RESET_RESULT' })
            switch (resultdepartment) {
                case 'departmentCreated':
                    Swal.fire({
                        showConfirmButton: true,
                        showCancelButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('admin.departments.addsuccess')
                    }).then(() => {
                        setModalShow(false)
                    })
                    break;
                case 'departmentUpdated':
                    Swal.fire({
                        showConfirmButton: true,
                        showCancelButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('admin.departments.editsuccess')
                    }).then(() => {
                        setModalShow(false)
                    })
                    break;
                default:
                    Swal.fire({
                        showConfirmButton: true,
                        showCancelButton: false,
                        confirmButtonText: t('global.ok'),
                        icon: 'info',
                        text: resultdepartment
                    })
                    break;
            }
        }
    }, [resultdepartment, dispatch, t])

    const columnsDepartments = [
        // {
        //     name: t('admin.departments.code'),
        //     cell: department =>
        //         <div className='cursor' onClick={() => selectDepartment(department)}>
        //             {department.code}
        //         </div>,
        //     selector: (department) => department.code,
        //     sortable: true,
        // },
        {
            name: t('admin.departments.name'),
            minWidth: '200px',
            cell: department =>
                <div className='cursor' onClick={() => selectDepartment(department)}>
                    {department.name}
                </div>,
            selector: (department) => department.name,
            sortable: true,
        }, {
            name: t('global.actions'),
            width: '100px',
            minWidth: '100px',
            cell: department =>
                <div>
                    <i className='fas fa-pencil me-2 cursor' onClick={() => selectDepartment(department)}></i>
                </div>,
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        }
    ]

    const filteredDepartments = (departments || []).filter(dept =>
        dept?.name?.toLowerCase().includes(search.toLowerCase())
    )

    return (
        <>
            <div className="toolbar">
                <div className="toolbar-left">
                    <div className="input-group" style={{ maxWidth: '320px' }}>
                        <span className="input-group-text"><i className="fas fa-search"></i></span>
                        <input
                            type="text"
                            className="form-control"
                            placeholder={t('admin.departments.name')}
                            value={search}
                            onChange={e => setSearch(e.target.value)}
                        />
                    </div>
                </div>
                <div className="toolbar-right">
                    <Button variant="success" onClick={openModal}>
                        <i className="fas fa-plus"></i>{t('admin.departments.add')}
                    </Button>
                </div>
            </div>

            {loading ? (
                <Loader />
            ) : (
                <div className="card-simple">
                    <CustomDataTable
                        columns={columnsDepartments}
                        data={filteredDepartments}
                        pagination={true}
                        exportable={true}
                        printable={true}
                        filter={true}
                    />
                </div>
            )}
            <Modal show={modalShow} onHide={closeModal} size="md" centered>
                <Modal.Header closeButton>
                    <Modal.Title>{isEditing ? t('admin.departments.edit') : t('admin.departments.add')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form onSubmit={handleSubmit}>
                        <Row>
                            {/* <Col xs={12} md={6} className="my-2">
                                <label>{t('admin.departments.code')}</label>
                                <input
                                    className="form-control"
                                    type='text'
                                    name='code'
                                    value={formState.code || ''}
                                    onChange={handleInputChange}
                                    required
                                />
                            </Col> */}
                            <Col xs={12} className="my-2">
                                <label>{t('admin.departments.name')}</label>
                                <input
                                    className="form-control"
                                    type='text'
                                    name='name'
                                    value={formState.name || ''}
                                    onChange={handleInputChange}
                                    required
                                />
                            </Col>
                        </Row>
                        {/* <Row>
                            <Col xs={12} className="my-2">
                                <input
                                    type="checkbox"
                                    name="active"
                                    checked={formState.active !== false}
                                    onChange={({ target }) => setFormState({ ...formState, active: target.checked })}
                                    className="form-check-input me-2"
                                />
                                <label>{t('admin.departments.active')}</label>
                            </Col>
                        </Row> */}
                        <Row className="mt-4">
                            <Col className="d-flex justify-content-end align-items-center">
                                <Button variant="secondary" onClick={closeModal} className="me-2">
                                    <i className="fas fa-times me-2"></i>{t('global.cancel')}
                                </Button>
                                <Button variant="primary" type="submit" disabled={isRegistering}>
                                    <i className="fas fa-save me-2"></i>{t('global.save')}
                                </Button>
                            </Col>
                        </Row>
                    </form>
                </Modal.Body>
            </Modal>
        </>
    )
}
